import { money, pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetAllTransfers = gql`
  query GetAllTransfers($after: String) {
    transfers(after: $after) {
      edges {
        node {
          id
          description
          type
          value {
            ...money
          }
          sourceAccount {
            name
            nickname
            accountNumber
            routingNumber
            iconUrl
          }
          destinationAccount {
            id
            name
            nickname
            accountNumber
            routingNumber
            iconUrl
          }
          status
          createdAt
          details {
            id
            title
            items {
              ... on TransferDetailItemAccountName {
                id
                title
                description
                accountId
                value
              }
              ... on TransferDetailItemDate {
                id
                title
                copy
                description
              }
              ... on TransferDetailItemStatus {
                id
                title
                copy
                description
              }
              ... on IDetailItem {
                id
                title
                description
                __typename
              }
              ... on ITransferDetailItem {
                id
                title
                description
                __typename
              }
              ... on IDetailCopyItem {
                copy
                __typename
              }
            }
          }
        }
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
  ${money}
  ${pageInfo}
`;

export default GetAllTransfers;
